module.exports = __webpack_public_path__ + "img/ssjt.8d145134.png";